<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card header="Arrumajes Asignados">
          <div class="table-responsive rqTable">
            <div class="form-group form-inline pull-left">
              <select v-model="numPages" class="form-control">
                <option v-for="(num,k) in [10, 30, 50, 100]" :key="k" :value="num">{{ num }}</option>
              </select>&nbsp;
              <input v-model="search" type="search" class="form-control" placeholder="Buscar"> &nbsp;
            </div>
            <div class="form-group form-inline pull-right">
              <date-picker
                v-model="date.start"
                lang="es"
                type="date"
                placeholder="Desde"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <date-picker
                v-model="date.end"
                lang="es"
                type="date"
                placeholder="Hasta"
                required
                format="DD/MM/YYYY"
              ></date-picker>&nbsp;
              <button class="btn btn-primary" @click="getRqs()">Buscar</button>&nbsp;
              <download-excel
                class="btn btn-primary"
                :data="filteredRqs"
                :fields="json_fields"
                name="Arrumajes_asignados.xls"
              >Descargar Excel</download-excel>
            </div>
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>
                    <span v-b-tooltip.hover title="Entrega de documentación">
                    <i class="fa fa-file"></i>
                    </span>
                  </th>
                  <th>#RQ</th>
                  <th>#RQ original</th>
                  <th>Fecha</th>
                  <th>Cliente</th>
                  <th>Placa</th>
                  <th>Celular</th>
                  <th>Conductor</th>
                  <th>Contenedor</th>
                  <th>Fecha de sobre estadía</th>
                  <th>Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(rq,k) in paginated('filteredRqs')"
                  :key="k"
                  @contextmenu.prevent="selectRq(rq)"
                  :class="rq.driver_confirm === constants.ACEPTA_CONDUCTOR ? 'accepted' : ''"
                >
                  <td><input type="checkbox" v-model="rq.doc_delivery" @click="setDocDelivery(rq)"></td>
                  <td>{{rq.id}}</td>
                  <td>{{rq.service.requeriment_id}}</td>
                  <td>{{rq.date | formatDateTime}}</td>
                  <td>{{rq.service.company ? rq.service.company.name : ''}}</td>
                  <td>{{rq.truck.plate}}</td>
                  <td>{{rq.truck.mobile}}</td>
                  <td>{{rq.driver ? `${rq.driver.name} ${rq.driver.last_name}` : '--'}}</td>
                  <td>{{rq.container_number}}</td>
                  <td>{{rq.container_expiration | formatDate}}</td>
                  <td>{{rq.status.name}}</td>
                </tr>
              </tbody>
            </table>
            <paginate
              name="filteredRqs"
              :list="filteredRqs"
              class="paginate-list"
              :per="numPages"
              :refreshCurrentPage="false"
            ></paginate>
            <paginate-links
              for="filteredRqs"
              :limit="5"
              :show-step-links="true"
              :step-links="{
                next: '>>',
                prev: '<<'
              }"
              :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
            ></paginate-links>

            <context-menu id="context-menu" ref="ctxMenu">
              <li @click="Detail()" class="ctx-item">Ver detalle</li>
              <li @click="unAssign()" class="ctx-item">Desasignar</li>
            </context-menu>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  data() {
    return {
      rq: {},
      rqs: [],
      status: [],
      numPages: 100,
      paginate: ["filteredRqs"],
      json_fields: {
        "#RQ": "id",
        "#RQ Original": "service.requeriment_id",
        // 'Servicio': 'service.service_type.name',
        "Fecha (cita)": {
          field: "date",
          callback: value => {
            return moment(value).format("DD/MM/YYYY HH:mm");
          }
        },
        Cliente: "service.company.name",
        Placa: "truck.plate",
        Celular: "truck.mobile",
        Conductor: {
          field: "driver",
          callback: driver => {
            return driver ? `${driver.name} ${driver.last_name}` : "";
          }
        },
        Contenedor: "container_number",
        "Sobre estadia": {
          field: "expiration_date",
          callback: value => {
            return moment(value).isValid()
              ? moment(value).format("DD/MM/YYYY")
              : "";
          }
        },
        Estado: "status.name"
      },
      search: "",
      date: {
        start: moment().format("YYYY-MM-DD 00:00"),
        end: moment().format("YYYY-MM-DD 23:59:59")
      }
    };
  },
  computed: {
    filteredRqs() {
      const searchWord = this.search.toLowerCase();
      return this.rqs.filter(rq => {
        let condition =
          rq.status.code !== constants.APROBADO &&
          rq.status.code !== constants.FINALIZADO;

        if (this.search) {
          condition =
            condition &&
            (rq.service.company.name.toLowerCase().includes(searchWord) ||
              rq.truck.plate.toLowerCase().includes(searchWord) ||
              // rq.service.doc_number.toLowerCase().includes(searchWord) ||
              searchWord === rq.id.toString());
        }
        return condition;
      });
    }
  },
  methods: {
    getRqs() {
      this.constants = constants;
      const data = {
        service_code: [constants.ARRUMAJE],
        finish: false,
        assigned: true,
        date_start: moment(this.date.start).format("YYYY-MM-DD 00:00:00"),
        date_end: moment(this.date.end).format("YYYY-MM-DD 23:59:59")
      };
      api.post("list_requeriments", data).then(response => {
        this.rqs = response.requeriments;
      });
    },
    setDocDelivery(rq){
      api.put(`/requeriments/${rq.id}`, {doc_delivery: !rq.doc_delivery}).then(response => {
        this.$toastr.success('Actualizado.', "Entrega de documentación", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      })
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    Detail() {
      this.$router.push(`/requeriments/import/detail/${this.rq.id}`);
    },
    unAssign() {
      if (
        confirm(
          `¿Seguro desea desasignar el requerimiento #${
            this.rq.id
          } al camión con matricula ${this.rq.truck.plate}?`
        )
      ) {
        let status = constants.APROBADO;
        if (this.rq.status.code !== constants.ASIGNADO) {
          status = this.rq.status.code;
        }

        let data = {
          status_id: this.status.find(st => st.code === status).id,
          truck_id: null,
          driver_id: null,
          driver_confirm: null
        };
        api.put(`/requeriments/${this.rq.id}`, data).then(response => {
          if (response.success) {
            alert("Requerimiento desasignado.");

            if (this.rq.driver_id) {
              let data_push = {
                user_id: this.rq.driver_id,
                headings: "Requerimiento desasignado",
                contents: "desasignado",
                data: { requeriment_id: this.rq.id }
              };
              api.post("/send_push", data_push).then(response => {
                console.log(response);
              });
            }

            this.$socket.emit("updateRequerimentServer", response.requeriment);
          }
        });
      }
    }
  },
  mounted() {
    this.getRqs();

    api.get("/statuses").then(response => {
      this.status = response.status;
    });
  },
  sockets: {
    connect: function() {
      console.log("socket connected");
    },
    updateRequeriment: function(rq) {
      console.log(rq);
      let index = this.rqs.findIndex(r => r.id === rq.id);
      if (index >= 0 && rq.truck_id) {
        this.rqs.splice(index, 1, rq);
      } else if (!rq.truck_id) {
        this.rqs.splice(index, 1);
      }
    }
  }
};
</script>